import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Dialog, Button, Classes } from '@blueprintjs/core';

export default function LocationEvents({ token, device }) {
  const [mobilePanicStream, setMobilePanicStream] = useState(false);

  const [events, setEvents] = useState([]);

  useEffect(() => {
    console.log('reconnect');
    let connection = new WebSocket(
      window.location.origin.replace('http', 'ws') + '/api/v0/events/stream',
      [token]
    );

    connection.onopen = function () {
      connection.send('Ping'); // Send the message 'Ping' to the server
    };

    // Log errors
    connection.onerror = function (error) {
      console.log('WebSocket Error ' + error);
    };

    connection.onclose = function (error) {
      console.log('WebSocket Closed ' + error);
    };

    // Log messages from the server
    connection.onmessage = function (e) {
      const newEvents = JSON.parse(e.data);
      newEvents.sort((a, b) => {
        if (a.time > b.time) {
          return 1;
        } else {
          return -1;
        }
      });
      setEvents((oldEvents) => {
        const output = [];
        let i = 0,
          j = 0;
        while (i < oldEvents.length && j < newEvents.length) {
          if (oldEvents[i].time < newEvents[j].time) {
            output.push(oldEvents[i++]);
          } else {
            output.push(newEvents[j++]);
          }
        }
        while (i < oldEvents.length) {
          output.push(oldEvents[i++]);
        }
        while (j < newEvents.length) {
          output.push(newEvents[j++]);
        }
        return output;
      });
    };
    return () => {
      connection.close();
    };
  }, [token]);

  const filtered = events.filter((event) => event.deviceUuid === device.deviceUuid);
  filtered.reverse();
  if (!filtered.length) {
    return 'no events';
  }
  return (
    <>
      <table className='bp3-html-table bp3-html-table-condensed bp3-interactive'>
        <tbody>
          {filtered.map((event, index) => {
            const {
              // deviceUuid,
              deviceNodeUuid,
              time,
              type,
              icon,
              misc,
              user,
              state,
              text,
              zone,
              delayInSec,
            } = event;
            let miscFormatted = misc;
            let match;
            if ((match = misc.match(/^Panic session (.+)$/))) {
              miscFormatted = (
                <>
                  Panic session{' '}
                  <Button
                    onClick={() => {
                      setMobilePanicStream({
                        deviceNodeUuid,
                        panicSessionId: match[1],
                      });
                    }}
                  >
                    {match[1]}
                  </Button>
                </>
              );
            }

            return (
              <tr key={'event' + index}>
                <td>{moment(time).fromNow()}</td>
                <td>{user}</td>
                <td>{text}</td>
                <td>{miscFormatted}</td>
                <td>{icon}</td>
                <td>{type}</td>
                <td>{state}</td>
                <td>{zone}</td>
                <td>{delayInSec}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {mobilePanicStream && (
        <MobilePanicStreamDialog
          {...mobilePanicStream}
          token={token}
          onClose={() => setMobilePanicStream(false)}
        />
      )}
    </>
  );
}

function MobilePanicStreamDialog({ onClose, token, deviceNodeUuid, panicSessionId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let connection = new WebSocket(
      window.location.origin.replace('http', 'ws') +
        `/api/v0/mobile-panics/${deviceNodeUuid}/sessions/${panicSessionId}/stream`,
      [token]
    );

    // Log errors
    connection.onerror = function (error) {
      console.log('WebSocket Error ' + error);
    };

    // Log messages from the server
    connection.onmessage = function (e) {
      setData(JSON.parse(e.data));
    };
    return () => {
      connection.close();
    };
  }, [deviceNodeUuid, panicSessionId, token]);

  return (
    <Dialog
      isOpen
      onClose={() => {
        onClose();
      }}
    >
      <div className={Classes.DIALOG_BODY}>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>
    </Dialog>
  );
}
